import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { CustomField } from '@klickdata/core/custom-field';
import { Resource } from '@klickdata/core/resource';
import { Utils } from '@klickdata/core/util';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
@Component({
    selector: 'app-resources-custom-fields',
    templateUrl: './resources-custom-fields.component.html',
    styleUrls: ['./resources-custom-fields.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ResourcesCustomFieldsComponent extends OnDestroyHandler implements OnInit {
    @Input() public resource: Resource;
    @Input() public customFields: CustomField[];
    public resourceForm: FormGroup;
    Utils = Utils;

    constructor(
        protected parentFormDirective: FormGroupDirective,
        protected fb: FormBuilder,
        @Inject(LOCALE_ID) protected localeId: string
    ) {
        super();
        this.resourceForm = parentFormDirective.form;
        this.localeId = localeId === 'en' ? 'en-US' : localeId;
    }

    ngOnInit(): void {
        this.setCustomFieldsValues(this.customFields);
        this.customFieldFormArray.markAsPristine();
    }
    get customFieldFormArray(): FormArray {
        return <FormArray>this.resourceForm.get('custom_fields');
    }
    private setCustomFieldsValues(custom_fields: CustomField[]) {
        // Clear the existing FormArray
        this.customFieldFormArray.clear();
        // Add the new form groups to the FormArray
        custom_fields.forEach((field) => {
            this.customFieldFormArray.push(
                this.fb.group({
                    id: [field.id],
                    value: [this.resource ? this.getCustomFieldValue(field.id) : null],
                    name: [field.name],
                    placeholder: [field.placeholder],
                    options: [field.options],
                    type: [field.type],
                    default: [field.default],
                })
            );
        });
    }

    private getCustomFieldValue(id: number): any {
        return this.resource.custom_fields?.find((cf) => cf.id === id)?.value;
    }
}
